import { withInstall } from '@touchvue/utils';
import Fix from './src/Fix.vue';

export const ToFix = withInstall(Fix);
export default ToFix;

export * from './src/fix';
